import { BehaviorSubject } from "rxjs";

export const fullPageSubject=new BehaviorSubject(0);
export const noMarginsSubject=new BehaviorSubject(0);
export const headerHeightSubject=new BehaviorSubject(0);